export default __webpack_public_path__ + "static/media/shadow-footer-reviews.06a1da2a.svg";